<template>
    <div class="first-message-block">
      <el-button round>立即联系</el-button>
      <span>177-2473-1490</span>
      <h1>1500,00 家企业正在使用跑团邦</h1>
    </div>
</template>

<script>
export default {
  name: 'FirstMessage'
}
</script>

<style scoped lang="stylus">
  .first-message-block
    width: 100%
    text-align: center
    padding-top: 44px
    padding-bottom: 62px
    .el-button
      width: 257px
      height: 48px
      border-radius: 25px
      background-color: #db1d2d
      color: white
      font-size: 20px
      font-weight: 400
      border: none
    span
      margin-left: 42px
      font-size: 20px
      color: #c92131
    h1
      font-weight: 400
      margin-top: 56px
      letter-spacing: 6px
</style>



// WEBPACK FOOTER //
// src/pages/home/components/FirstMessage.vue